import { useRef, useState } from 'react';

import { cn } from '@/lib/utils';
import { Button, ButtonVariants } from '@/components/button';
import { Input } from '@/components/input';

export const FileUploadButton: React.FC<{
  text?: string;
  className?: string;
  onUpload?: (files: File[]) => Promise<void>;
  variant?: ButtonVariants['variant'];
}> = ({ text = 'Upload', className, onUpload, variant }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [saving, setSaving] = useState(false);

  return (
    <div className="z-10">
      <Input
        ref={inputRef}
        type="file"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        onChange={async (e) => {
          const files = Array.from(e.target.files ?? []);
          setSaving(true);
          await onUpload?.(files);
          setSaving(false);
          inputRef.current!.value = '';
        }}
        className="hidden"
      />
      <Button
        loading={saving}
        type="submit"
        className={cn('', className)}
        onClick={() => inputRef.current?.click()}
        variant={variant}
      >
        {text}
      </Button>
    </div>
  );
};
